import { useEffect } from 'react'
import Router from 'next/router'

const ScrollToTop = () => {
  useEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    window.scrollTo(0, 0)

    const handleRouteChange = () => {
      window.scrollTo(0, 0)
    }

    Router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  return null
}

export default ScrollToTop
